var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"amd"},_vm._l((_vm.data),function(value,index){return _c('ViewCard',{key:index,attrs:{"data":value,"title":"Software y Diseño","tipo":"AMD"}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }